var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContractIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "contractWhiteIcon 2",
    clipPath: "url(#clip0_6610_10670)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.56778 16.4006H3.56528H0L0.0828085 20.7542C0.0828085 20.7583 0.0830354 20.7624 0.0830354 20.7663C0.0830354 22.5233 1.50689 23.9528 3.25692 23.9528L17.6337 23.9999C16.7791 23.1874 16.2466 22.0461 16.2466 20.784V16.4001L3.56778 16.4006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.7583 23.9716C22.5455 23.9716 23.9998 22.5421 23.9998 20.7851V1.27551C23.9998 0.572186 23.4299 0 22.7293 0H5.62394C4.92972 0 4.35956 0.567148 4.35347 1.26414L4.2085 15.1259H16.8819C17.2326 15.1259 17.5171 15.4115 17.5171 15.7637V20.7853C17.5171 22.5424 18.971 23.9716 20.7583 23.9716ZM8.11685 4.56635H20.0096C20.3604 4.56635 20.6449 4.85197 20.6449 5.20413C20.6449 5.55627 20.3604 5.84192 20.0096 5.84192H8.11685C7.76611 5.84192 7.48159 5.55629 7.48159 5.20413C7.48159 4.852 7.76608 4.56635 8.11685 4.56635ZM8.11685 10.7518C7.76611 10.7518 7.48159 10.4661 7.48159 10.114C7.48159 9.76184 7.76608 9.4762 8.11685 9.4762H19.915C20.2657 9.4762 20.5502 9.76182 20.5502 10.114C20.5502 10.4661 20.2657 10.7518 19.915 10.7518H8.11685Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6610_10670"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractIcon);
export default __webpack_public_path__ + "static/media/contractIcon.b03198bf84e73fa06d45be9e6332afed.svg";
export { ForwardRef as ReactComponent };